export default "__VITE_ASSET__CXXlBvuH__"